/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import { components } from '@glowingblue-orell-thalia-common';
import type Mithril from 'mithril';

const { MobileTour } = components;

export default class ReviewsTour extends MobileTour {
	oninit(vnode: Mithril.Vnode) {
		// Grandparent oninit(), skipping MobileTour's.
		Reflect.apply(Component.prototype.oninit, this, [vnode]);

		this.cardIds = ['reviews.link-account', 'reviews.bulk-export', 'reviews.single-export', 'reviews.updates', 'reviews.status', 'reviews.more'];
	}

	complete() {
		this.shouldNotSaveDisabled = true;
		super.complete();
	}
}
